import Page from '@components/Page';
import { FC } from 'react';
import useLocales from '@hooks/useLocales';
import { Box, useTheme } from '@mui/material';
import { useStyles } from './styles';
import TopBlock from './top-block/TopBlock';
import SolutionsBlock from './solution-block/SolutionsBlock';
import LaptopBlock from './laptop-block/LaptopBlock';
import LoFinancialPerfomanceBlock from './lo-financial-perfomance-block/LoFinancialPerfomanceBlock';
import CrmBlock from './crm-block/CrmBlock';
import MyCompanyBlock from './my-company-block/MyCompanyBlock';
import ListBlock from './list-block/ListBlock';
import AreYouNewBlock from './are-you-new-block/AreYouNewBlock';
import GetStartedBlock from './get-started-block/GetStartedBlock';
import FooterBlock from './footer-block/FooterBlock';

const Landing: FC = () => {
  const { t } = useLocales();
  const theme = useTheme();
  const styles = useStyles(theme);

  return (
    <Page title={t('landing.landing')}>
      <Box sx={styles.generalContainer}>
        <TopBlock />
        <SolutionsBlock />
        <LaptopBlock />
        {/* <LoGeneralInfoBlock /> */}
        <Box sx={styles.featuresContainer}>
          <LoFinancialPerfomanceBlock />
          <CrmBlock />
          <MyCompanyBlock />
        </Box>
        <Box sx={styles.featuresContainer}>
          <ListBlock />
        </Box>
        {/* <LikeVideoBlock /> */}
        {/* Removed 'Testimonials' block by the customer request */}
        {/* <ClientsSayBlock /> */}
        <AreYouNewBlock />
        <GetStartedBlock />
        <FooterBlock />
      </Box>
    </Page>
  );
};

export default Landing;
